var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "columns custom-columns is-flex is-vcentered",
      attrs: { id: "prospect-info" },
    },
    [
      _vm.name && _vm.lastName && _vm.email
        ? _c("div", { staticClass: "column user-data" }, [
            _c("span", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.name) + " " + _vm._s(_vm.lastName)),
            ]),
            _c("span", { staticClass: "email" }, [_vm._v(_vm._s(_vm.email))]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass:
            "column pl-0 pr-0 is-one-fifth user-avatar is-flex is-align-content-center",
        },
        [_c("AvatarShow", { attrs: { "show-default": true } })],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }